module.exports = __webpack_public_path__ + "img/2025-08-16c_4.87703452.jpg";